<template>
  <client-only>
    <div class>
      <v-dialog v-model="openDialog" content-class="dialog-wrapper" width="500">
        <v-card>
          <div>
            <v-btn color="primary darken-1" class="closeBtn px-0" text @click="close">X</v-btn>
          </div>
          <v-card-text>
            <v-container py-3>
              <h3 class="display-18 text-center">{{dialogContent}}</h3>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </client-only>
</template>

<script>
export default {
  props: {
    openDialog: {
      type: Boolean,
      default: false
    },
    dialogContent: {
      type: String,
      default: 'תודה על שיתוף הפעולה 😀'
    }
  },
  data() {
    return {
      dialog: false
    }
  },
  methods: {
    close() {
      this.$emit('closeDialog', false)
    }
  },
  
}
</script>


<style lang="scss" scoped>
.dialog-wrapper {
  text-align: left;
  transform: translateY(-25px);
  color: #000;
  width: 400px;
}

.closeBtn {
  color: #000;
  font-weight: 400;
  position: absolute;
  left: 0;
  top: 0;
  font-size: 18px;
}
</style>